import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'nae'
})
export class NaePipe implements PipeTransform {
    transform(items: any[]): any[] {

        return items.filter(it => {
            return true;
        });
    }
}
